import { CompanyType } from 'src/types';

import { faWhatsapp } from '@fortawesome/free-brands-svg-icons';
import Link from 'next/link';
import Script from 'next/script';
import { Lia } from 'src/components/ui/Lia';
import { Text } from 'src/components/ui/Text';
import { cn } from 'src/utils/tailwind';
import { Icon } from '../ui/Icon';

type FooterProps = {
  company: CompanyType;
  className?: string;
};

const Footer = (props: FooterProps) => {
  return (
    <footer className={cn('flex flex-col gap-3', props.className)}>
      <Text
        className="text-foreground-least"
        size="sm"
      >
        A entrega do produto ou serviço é de responsabilidade de{' '}
        <Text
          as="span"
          className="text-foreground-least"
          weight="bold"
          size="sm"
        >
          {props.company.name}
        </Text>
        .
      </Text>

      <div>
        <Text
          className="text-foreground-least"
          size="sm"
          data-testid="contact"
        >
          Em caso de dúvidas, ligue para{' '}
          <Link
            href="tel:08009425507"
            target="_blank"
            className="font-medium underline hover:text-foreground-subtle"
          >
            0800 942 5507
          </Link>{' '}
          ou fale via{' '}
          <Link
            href="https://atendimento.lia.com.br/whatsapp"
            target="_blank"
            className="inline-flex items-center gap-1 font-medium underline hover:text-foreground-subtle"
          >
            whatsapp{' '}
            <Icon
              size="md"
              icon={faWhatsapp}
            />
          </Link>
        </Text>
      </div>

      <div className="mt-7 flex flex-wrap items-center justify-between gap-5">
        <div className="order-2 flex basis-full items-center gap-2 sm:order-1 sm:flex-1">
          <Lia
            variant="mono"
            className="h-[24px] w-[36px]"
          />
          <Text
            className="w-full text-foreground-least sm:w-auto"
            weight="bold"
            size="sm"
          >
            © todos os direitos reservados
          </Text>
        </div>

        <div
          id="ra-verified-seal"
          className="order-1 w-[136px] sm:order-2"
        >
          <Script
            async
            type="text/javascript"
            id="ra-embed-verified-seal"
            src="https://s3.amazonaws.com/raichu-beta/ra-verified/bundle.js"
            data-id="NGVaUW1uZ0k2YmhfN3NsQjpsaWE="
            data-target="ra-verified-seal"
            data-model="2"
          />
        </div>
      </div>
    </footer>
  );
};

export { Footer };
